<template>
  <div>

    <!-- content -->
    <slot name="header" />

    <section :class="{'padding_top': !noPaddingTop}">
      <slot />
    </section>

    <slot name="footer" />
    <!-- //content -->

  </div>
</template>

<script>
  export default {
    name: 'PageLayout',
    props: {
      noPaddingTop: {
        default: false,
        type: Boolean
      }
    }
  }
</script>

<style scoped>
  .padding_top_50 {
    padding-top: 50px;
  }
</style>
